module.exports = __webpack_public_path__ + "static/media/Service5image.d2ca16e9.svg";